import { render } from "./testGame.vue?vue&type=template&id=3b53dbae"
import script from "./testGame.vue?vue&type=script&lang=js"
export * from "./testGame.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__